var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0823 10.1693C12.7508 10.1693 12.4328 10.301 12.1984 10.5355C11.964 10.7699 11.8323 11.0878 11.8323 11.4193C11.8323 11.7509 11.964 12.0688 12.1984 12.3032C12.4328 12.5376 12.7508 12.6693 13.0823 12.6693H18.9156C19.2472 12.6693 19.5651 12.5376 19.7995 12.3032C20.0339 12.0688 20.1656 11.7509 20.1656 11.4193C20.1656 11.0878 20.0339 10.7699 19.7995 10.5355C19.5651 10.301 19.2472 10.1693 18.9156 10.1693H13.0823ZM22.6573 9.41268C22.6248 8.93869 22.4135 8.49472 22.0663 8.17049C21.719 7.84626 21.2616 7.66596 20.7865 7.66602H11.2031L11.0748 7.67018C10.6008 7.7027 10.1568 7.91394 9.8326 8.26122C9.50837 8.6085 9.32807 9.06591 9.32813 9.54102V22.4577L9.33229 22.586C9.36481 23.06 9.57605 23.504 9.92333 23.8282C10.2706 24.1524 10.728 24.3327 11.2031 24.3327H20.7865L20.9148 24.3285C21.3888 24.296 21.8328 24.0848 22.157 23.7375C22.4812 23.3902 22.6615 22.9328 22.6615 22.4577V9.54102L22.6573 9.41268ZM11.2031 8.91602H20.7865L20.8715 8.92185C21.0211 8.94239 21.1582 9.01642 21.2575 9.13024C21.3568 9.24406 21.4115 9.38998 21.4115 9.54102V22.4577L21.4056 22.5427C21.3851 22.6923 21.3111 22.8294 21.1972 22.9287C21.0834 23.028 20.9375 23.0827 20.7865 23.0827H11.2031L11.1181 23.0768C10.9685 23.0563 10.8314 22.9823 10.7321 22.8685C10.6328 22.7546 10.5781 22.6087 10.5781 22.4577V9.54102L10.584 9.45602C10.6045 9.30639 10.6785 9.16926 10.7924 9.06999C10.9062 8.97072 11.0521 8.91602 11.2031 8.91602Z",
    fill: "url(#paint0_linear_3410_9311)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3410_9311",
    x1: 21.58,
    y1: 7.66602,
    x2: 11.8106,
    y2: 15.8682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.eabba1f4.svg";
export { ForwardRef as ReactComponent };